var ctrl = function($scope, $http, Flash, $window) {
  $scope.go = function() {
    $http({
      method: 'GET',
      url: '/api/admin/users/' + $scope.user.id + '/hubspot_link'
    }).then(function success(res) {
      $window.open(res.data.link, "_blank");
    }, function error(res) {
      Flash.setMessage("We had a problem loading this user's hubspot info - please contact a dev. " + res.data);
    });
  }
};
ctrl.$inject = ['$scope', '$http', 'Flash', '$window'];

tiz.controller('HubspotLinkCtrl', ctrl);

var directive = function(C) {
  return {
    controller: 'HubspotLinkCtrl',
    restrict: 'E',
    scope: {user: '='},
    templateUrl: require('../templates/hubspot_link.html')
  };
};

directive.$inject = ['C'];

tiz.directive('hubspotLink', directive);
